/** Marks a get-by-id query so 403/404 responses show the shared error view. */
export const RESOURCE_QUERY_META = { resource: true } as const;
